import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "bell",
  "use": "bell-usage",
  "viewBox": "0 0 12 14.625",
  "content": "<symbol viewBox=\"0 0 12 14.625\" id=\"bell\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M6 14.625c.825 0 1.5-.675 1.5-1.5h-3a1.5 1.5 0 0 0 1.5 1.5m4.5-4.5v-3.75c0-2.302-1.23-4.23-3.375-4.74v-.51C7.125.502 6.623 0 6 0S4.875.502 4.875 1.125v.51c-2.152.51-3.375 2.43-3.375 4.74v3.75l-1.5 1.5v.75h12v-.75l-1.5-1.5z\" /></symbol>"
});
var result = sprite.add(symbol);
export default "#" + symbol.id


//////////////////
// WEBPACK FOOTER
// ./application/components/dumb/icon/src/bell.svg
// module id = 146
// module chunks = 0